{
  "dismiss": "Lõpeta"
}